import { ReactNode, createContext, useEffect, useState } from 'react'
import { getGeneralSettings } from '../services/generalSetting';
import { baseURL, tenantId } from '../config/api';
import { checkServerHealth } from '../services/Health';

const WebDataContext = createContext({});

export const WebDataProvider = ({ children }: { children: ReactNode }) => {
    const [webData, setWebData] = useState<any | null>({});

    const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

    const waitForServer = async (healthCheck: (tenantId: string) => Promise<boolean>, serverName: string) => {
        const delayTime = 5000;

        while (true) {
            try {
                const isAlive = await healthCheck(tenantId);

                if (isAlive) {
                    console.log(`${serverName} is alive`);
                    return true;
                }

                console.log(`${serverName} not ready, retrying...`);
            } catch (error) {
                console.log(`${serverName} health check error, retrying...`);
            }

            await delay(delayTime);
        }
    }

    const loadSettings = async () => {
        await getGeneralSettings(tenantId)
            .then(data => {
                let dateFormat = "MM/DD/yyyy";

                if (data[0]?.preferredDateFormat) {
                    switch (parseInt(data[0]?.preferredDateFormat)) {
                        case 0:
                        case 4:
                            dateFormat = "MM/DD/yyyy";
                            break;
                        case 1:
                        case 2:
                            dateFormat = "yyyy-MM-DD";
                            break;
                        case 3:
                            dateFormat = "DD-MM-yyyy";
                            break;
                        case 5:
                            dateFormat = "DD/MM/yyyy";
                            break;
                        case 6:
                        case 8:
                            dateFormat = "DD.MM.yyyy";
                            break;
                        case 7:
                            dateFormat = "DD-MMM-yyyy";
                            break;
                        default:
                            dateFormat = "MM/DD/yyyy";
                    }
                } else {
                    dateFormat = "MM/DD/yyyy";
                }
                setWebData({
                    ...data[0],
                    tentantLogo: `${baseURL}commonFile/Get?name=${data[0].tentantLogo}`,
                    favIcon: `${baseURL}commonFile/Get?name=${data[0].favIcon}`,
                    websiteIndexPageImage: `${baseURL}commonFile/Get?name=${data[0].websiteIndexPageImage}`,
                    websiteSubPageImage: `${baseURL}commonFile/Get?name=${data[0].websiteSubPageImage}`,
                    dateFormat
                });
            })
            .catch(error => console.error(error))
    }

    useEffect(() => {
        const initialize = async () => {
            try {
                const serverAlive = await waitForServer(checkServerHealth, "Server");

                if (serverAlive) {
                    await loadSettings();
                }
            } catch (error) {
                await loadSettings();
                console.error("Initialization failed:", error);
            }
        };

        initialize();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <WebDataContext.Provider value={{ webData, setWebData }}>
            {children}
        </WebDataContext.Provider>
    )
}

export default WebDataContext;